<template>
    <div>
      <CRow class="mb-3 search-panel">
        <CCol xs="12" sm="1" class="form-group" style="min-width: 105px; max-width: 120px;">
          <label>Thao tác</label>
          <div class="dropdown btn-group" style="height: 36px;">
            <button class="btn">
              <div class="group-checkbox">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" v-model="actionData.model.selectedAll"
                    @change="changeSelectAll" id="selectedAll" />
                  <label class="custom-control-label" for="selectedAll"></label>
                </div>
              </div>
            </button>
            <button type="button" class="dropdown-toggle dropdown-toggle-split btn" data-toggle="dropdown"
              aria-expanded="false" aria-haspopup="true"></button>
            <div class="dropdown-menu">
              <button :disabled="actionData.model.listSelectedId.length === 0" class="dropdown-item"
                @click="setupSelectOneAction('delete_list')" color="danger">
                <CIcon name="cil-trash" style="danger" class="mr-2" />
                Xóa tất cả
              </button>
            </div>
          </div>
        </CCol>
        <CCol sm="2" xs="12">
          <BaseInput :options="nameInput.options" :data="nameInput.data" :listener="nameInput.listener" />
        </CCol>
        <CCol>
          <div class="form-group">
            <label style="color: white"></label>
            <div style="margin-top: 10px">
              <CButton style="float: right;margin-left: 5px;" color="primary" v-c-tooltip.hover="'Tải lại'"
                class="btn-action-primary" @click="loadDataMainTable(true)">
                <i class="fa fa-refresh"></i>&nbsp;&nbsp;Tải lại
              </CButton>
              <CButton style="float: right;margin-left: 5px;" color="primary" v-c-tooltip.hover="'Tạo mới'"
                class="btn-action-primary" @click="clickAdd()">
                <i class="fa fa-plus"></i>&nbsp;Tạo mới
              </CButton>
            </div>
          </div>
        </CCol>
      </CRow>
      <CCard class="content-fade-in mt-3p5">
        <CCardBody>
          <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
            @row-click="rowClickTable($event)" ref="mainTable">
            <template #checkbox="{ item }">
              <td class="group-checkbox">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" v-model="actionData.model.listSelectedId"
                    :value="item.id" :id="item.id" v-c-tooltip.hover="'Selected'" />
                  <label class="custom-control-label" :for="item.id"></label>
                </div>
              </td>
            </template>
  
            <template #createDate="{ item }">
              <td>
                {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
              </td>
            </template>
            <template #action="{ item }">
              <td class="action-btn-group">
                <div class="action-btn-wrapper">
                  <CButton color="info" variant="outline" v-c-tooltip.hover="'Cập nhật'" square size="sm"
                    @click="setupUpdate(item.id)">
                    <CIcon name="cil-pencil" />
                  </CButton>
                  <CButton color="danger" variant="outline" class="ml-1" square size="sm" v-c-tooltip.hover="'Xóa'"
                    @click="setupSelectOneAction('delete_one', item.id, item.name)">
                    <CIcon name="cil-trash" />
                  </CButton>
                </div>
              </td>
            </template>
          </BaseTable>
        </CCardBody>
      </CCard>
  
      <CModal v-if="isShowModal" :title="dataSave.id.data.model ? 'Cập nhật đơn vị tính' : 'Tạo mới đơn vị tính'"
        :show.sync="isShowModal" :closeOnBackdrop="false">
        <CRow class="pb-2">
          <CCol sm="12" md="12" xl="12" xs="12">
            <BaseInput :options="dataSave.codeInput.options" :data="dataSave.codeInput.data" />
          </CCol>
          <CCol sm="12" md="12" xl="12" xs="12">
            <BaseInput :options="dataSave.nameInput.options" :data="dataSave.nameInput.data" />
          </CCol>
        </CRow>
        <template v-slot:footer>
          <button type="button" class="btn btn-secondary" @click="isShowModal = false"><i class="fa fa-times"></i> Hủy bỏ
          </button>
          <button type="button" class="btn btn-primary" @click="submitData()">
            <i class="fa fa-save" ></i> Lưu lại
          </button>
        </template>
        <BaseFormLoading :value="loading.value"></BaseFormLoading>
      </CModal>
  
      <BaseFormLoading :value="loading.value"></BaseFormLoading>
  
      <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping" ref="actionModal"></ModalConfirm>
    </div>
  </template>
  
  <script>
  import BaseTable from "../base/BaseDataTable";
  import ModalConfirm from "../base/BaseModalConfirm";
  import BaseInput from "../base/BaseInput";
  import BaseSwitch from "@/views/base/BaseSwitch";
  import BaseSelect from "@/views/base/BaseSelect2";
  import BaseFormLoading from "@/views/base/BaseFormLoading";
  
  export default {
    name: "UomList",
    components: {
      BaseSwitch,
      BaseTable,
      ModalConfirm,
      BaseInput,
      BaseSelect,
      BaseFormLoading
    },
    notifications: {
      showSuccessMsg: {
        type: "success",
        title: "Success"
      },
      showErrorMsg: {
        type: "error",
        title: "Error"
      },
      showWarningMsg: {
        type: "warn",
        title: "warn"
      }
    },
    data() {
      let that = this;
      let actionTypeMapping = new Map();
  
      actionTypeMapping.set("delete_one", {
        url: "/uom/delete",
        titlePopup: function () {
          return that.$helper.setupTitleAction(
            "xóa",
            "đơn vị tính",
            that.actionData.model.selectedName
          );
        },
        isJsonContentType: false,
        dataSubmit: function () {
          return { id: that.actionData.model.selectedId };
        },
        successCallback: function () {
          that.actionData.model.listSelectedId = [];
          that.showSuccessMsg({ message: "Xóa đơn vị tính " + that.actionData.model.selectedName + " thành công" });
          that.loadDataMainTable();
        }
      });
  
      actionTypeMapping.set("delete_list", {
        url: "/uom/delete-list",
        titlePopup: function () {
          return that.$helper.setupTitleAction("xóa", "các đơn vị tính", "đã chọn");
        },
        isJsonContentType: false,
        dataSubmit: function () {
          return {
            lsId: that.actionData.model.listSelectedId
          };
        },
        successCallback: function () {
          that.actionData.model.listSelectedId = [];
          that.showSuccessMsg({ message: "Xóa danh sách đơn vị tính thành công" });
          that.loadDataMainTable();
        },
      });
  
      return {
        loading: { value: false },
        actionData: {
          actionTypeMapping: actionTypeMapping,
          model: {
            selectedAll: false,
            selectedId: null,
            selectedName: null,
            listSelectedId: []
          }
        },
        nameInput: {
          options: {
            placeholder: "Tên đơn vị tính",
            label: 'Tên đơn vị tính',
          },
          data: {
            name: "name",
            model: "",
            updateTrigger: function () {
              return that.$refs.mainTable;
            }
          }
        },
        isDeleteSelect: {
          options: {
            placeholder: "Trạng thái",
            label: 'Trạng thái',
          },
          data: {
            name: "isDelete",
            model: false,
            updateTrigger: function () {
              return that.$refs.mainTable;
            }
          }
        },
        mainTable: {
          options: {
            fields: [
              { key: "checkbox", label: "#", sorter: false, filter: false },
              { key: "createDate", label: "Ngày tạo" },
              { key: "code", label: "Mã đơn vị tính" },
              { key: "name", label: "Tên đơn vị tính" },
              { key: "action", label: "Thao tác", sorter: false, filter: false }
            ],
            slots: ["checkbox", "createDate", "action"],
            sorter: true,
            columnFilter: false,
            clickableRows: true,
            hover: false,
            itemsPerPageSelect: { label: ' ', values: [15, 20, 30, 50, 100], external: true },
            pageSize: 20,
          },
          dataSource: {
            url: "/uom/getPages",
            dataSubmit: function () {
              that.actionData.model.listSelectedId = [];
              return that.$helper.setupDataSubmit(that.$data);
            },
            response: function (dataResponse) {
              return dataResponse.data;
            }
          }
        },
        isShowModal: false,
        dataSave: {
          id: {
            data: {
              name: "id",
              model: null
            }
          },
          codeInput: {
            options: {
              label: "Mã đơn vị tính <span class='required'>*</span>",
              placeholder: "Mã đơn vị tính",
              type: "text",
              disabled: false,
              maxlength: 64
            },
            data: {
              name: "code",
              model: "",
              updateCallback: function () {
                that.submitData();
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  let value = that.dataSave.codeInput.data.model;
                  if (value === "") {
                    this.isValid = false;
                    this.errorMessage = "Mã đơn vị tính không được để trống";
                  } else {
                    this.isValid = true;
                    this.errorMessage = "";
                  }
                  return this.isValid;
                }
              }
            }
          },
          nameInput: {
            options: {
              label: "Tên đơn vị tính <span class='required'>*</span>",
              placeholder: "Tên đơn vị tính",
              type: "text",
              maxlength: 256
            },
            data: {
              name: "name",
              model: "",
              updateCallback: function () {
                that.submitData();
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  let value = that.dataSave.nameInput.data.model;
                  if (value === "") {
                    this.isValid = false;
                    this.errorMessage = "Tên đơn vị tính không được để trống";
                  } else {
                    this.isValid = true;
                    this.errorMessage = "";
                  }
                  return this.isValid;
                }
              }
            }
          },
        },
      };
    },
    methods: {
      rowClickTable(value) {
        let targetClick = value.event.target;
        if (value.column === 'action' && ($(targetClick).is("i.fa")) ||
          $(targetClick).is("button") || $(targetClick).is("svg") || $(targetClick).is("path")) {
          return;
        }
        if (value && value.item && value.item.id) {
          if (this.actionData.model.listSelectedId.includes(value.item.id)) {
            const index = this.actionData.model.listSelectedId.indexOf(value.item.id)
            if (index > -1) { // only splice array when item is found
              this.actionData.model.listSelectedId.splice(index, 1); // 2nd parameter means remove one item only
              value.item._classes = 'inactive';
            }
          } else {
            value.item._classes = 'active';
            this.actionData.model.listSelectedId.push(value.item.id);
          }
        }
      },
      loadDataMainTable: function (isUpdateFilter) {
        this.$refs.mainTable.loadData(true, isUpdateFilter);
      },
      changeSelectAll: function (event) {
        let listSelectedId = this.actionData.model.listSelectedId;
        if (this.actionData.model.selectedAll) {
          this.actionData.model.listSelectedId = [];
  
          this.$refs.mainTable.items.forEach(each => {
            this.actionData.model.listSelectedId.push(each.id);
          });
        } else {
          this.actionData.model.listSelectedId = [];
        }
      },
      setupSelectOneAction: function (actionTypeKey, selectedId, selectedName, userIsEnable) {
        let actionData = this.actionData.model;
        actionData.selectedId = selectedId || null;
        actionData.selectedName = selectedName || null;
        actionData.userIsEnable = userIsEnable || null;
        this.$refs.actionModal.setCurrAction(actionTypeKey);
      },
      // setupSelectMoreAction: function (actionTypeKey) {
      //   this.$refs.actionModal.setCurrAction(actionTypeKey);
      // }
      clickAdd() {
        this.dataSave.codeInput.options.disabled = false;
        this.isShowModal = true;
      },
      setupUpdate(_id) {
        let that = this;
        that.dataSave.id.data.model = _id;
        that.$helper.loadDataSource({
          url: "/uom/findById",
          dataSubmit: function () {
            return {
              id: _id
            };
          },
          isJsonContentType: false,
          successCallback: function (response) {
            if (that.$helper.validResponse(that.$router, response.data)) {
              that.$helper.setupDataResponse(that.$data.dataSave, response.data.data);
              that.dataSave.codeInput.options.disabled = true;
              that.isShowModal = true;
            }
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
            that.loading.value = false
          }
        });
      },
  
      submitData: function () {
        let that = this;
        let isValid = true;
        isValid &= this.dataSave.codeInput.data.validator.valid();
        isValid &= this.dataSave.nameInput.data.validator.valid();
        if (!isValid) {
          return;
        }
  
        that.loading.value = true;
  
        that.$helper.loadDataSource({
          url: that.dataSave.id.data.model ? "/uom/update" : "/uom/create",
          dataSubmit: function () {
            return {
              id: that.dataSave.id.data.model,
              name: that.dataSave.nameInput.data.model,
              code: that.dataSave.codeInput.data.model,
            };
          },
          successCallback: function (response) {
            if (!that.$helper.validResponse(that.$router, response.data)) {
              that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
              that.$helper.setupErrorModel(response.data.data, that.$data.dataSave);
            } else {
              that.showSuccessMsg({ message: !that.dataSave.id.data.model ? "Tạo mới đơn vị tính thành công" : "Cập nhật đơn vị tính thành công" });
              that.isShowModal = false;
              that.loading.value = false;
              that.loadDataMainTable();
              that.clearDataSave();
            }
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
            that.loading.value = false
          }
        });
      },
      clearDataSave() {
        this.dataSave.codeInput.data.model = '';
        this.dataSave.codeInput.data.validator.isValid = true;
        this.dataSave.nameInput.data.model = '';
        this.dataSave.nameInput.data.validator.isValid = true;
        this.dataSave.id.data.model = null;;
      },
    },
    created: function () {
    },
    mounted() {
    },
    watch: {
      "actionData.model.listSelectedId": function (newValue) {
        let that = this;
        if (that.$refs.mainTable.items.length > 0 && newValue.length === that.$refs.mainTable.items.length) {
          that.actionData.model.selectedAll = true;
          that.$refs.mainTable.items.map(each => each._classes = 'active');
        } else {
          that.actionData.model.selectedAll = false;
          if (newValue.length == 0) {
            that.$refs.mainTable.items.map(each => each._classes = 'inactive');
          }
        }
      },
      isShowModal(value) {
        if (!value) {
          this.clearDataSave();
        }
      }
    },
    computed: {}
  };
  </script>
  <style scoped>
  .td-roles {
    max-width: 250px;
  }

  </style>
  